import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function ResearchApproach() {
  const approaches = [{
    number: '01',
    title: 'Experimental Methods',
    description: 'High-speed imaging, infrared thermography, and precision instrumentation to capture thermal-fluid phenomena at multiple scales.'
  }, {
    number: '02',
    title: 'Computational Modelling',
    description: 'CFD simulations, conjugate heat transfer analysis, and multiphase flow modelling to understand complex thermal systems.'
  }, {
    number: '03',
    title: 'Data-Driven Methods',
    description: 'Machine learning and AI-assisted design optimization for next-generation cooling solutions.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-white border-t border-gray-100" data-id="element-249">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-251">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-[#800000] font-serif mb-4" data-id="element-252">
            Our Approach
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-253">
            We combine three complementary methodologies to advance thermal
            transport science
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-254">
          {approaches.map((approach, index) => <motion.div key={index} variants={itemVariants} className="relative" data-id="element-255">
              {/* Large Number Background */}
              <div className="absolute -top-10 -left-4 text-8xl font-serif font-bold text-[#800000]/5 select-none z-0" data-id="element-256">
                {approach.number}
              </div>

              <div className="relative z-10 pt-8" data-id="element-257">
                <div className="w-12 h-12 bg-[#800000] text-white rounded-full flex items-center justify-center font-serif font-bold text-xl mb-6 shadow-md" data-id="element-258">
                  {approach.number}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 font-serif" data-id="element-259">
                  {approach.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-260">
                  {approach.description}
                </p>
              </div>

              {/* Subtle divider line for mobile */}
              {index !== approaches.length - 1 && <div className="md:hidden w-full h-px bg-gray-100 mt-12" data-id="element-261"></div>}
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}